import { gql } from "@apollo/client";

export const GET_OPT_IN_SENT_REQUESTS = gql`
  query GetInitiativesOptinSentRequests($organizationId: String!) {
    getInitiativesOptinSentRequests(organizationId: $organizationId) {
      id
      initiativeId
      organizationId
      status
      createdAt
      initiativeOwnerId
      initiativeAddress
      initiativeName
    }
  }
`;
